/**
 * Actions Types
 */

export enum PropostaTypes {
  DADOS_PROPOSTA_SUCCESS = '@refinanciamento/proposta/DADOS_PROPOSTA_SUCCESS',
  DADOS_PROPOSTA_ERROR = '@refinanciamento/proposta/DADOS_PROPOSTA_ERROR',
  DADOS_PROPOSTA_REQUEST = '@refinanciamento/proposta/DADOS_PROPOSTA_REQUEST',

  GET_PROPOSTAS_REQUEST = '@refinanciamento/proposta/GET_PROPOSTAS_REQUEST',
  GET_PROPOSTAS_SUCCESS = '@refinanciamento/proposta/GET_PROPOSTAS_SUCCESS',
  GET_PROPOSTAS_ERROR = '@refinanciamento/proposta/GET_PROPOSTAS_ERROR',

  SET_ID_ITERACAO = '@refinanciamento/proposta/criacao/SET_ID_ITERACAO',
  SET_TIPO_DOCUMENTO = '@refinanciamento/proposta/criacao/SET_TIPO_DOCUMENTO',

  DADOS_PROPOSTA_ANTIGA_SUCCESS = '@refinanciamento/proposta/DADOS_PROPOSTA_ANTIGA_SUCCESS',
  DADOS_PROPOSTA_ANTIGA_ERROR = '@refinanciamento/proposta/DADOS_PROPOSTA_ANTIGA_ERROR',
  DADOS_PROPOSTA_ANTIGA_REQUEST = '@refinanciamento/proposta/DADOS_PROPOSTA_ANTIGA_REQUEST',

  RESET = 'RESET',
}

export interface DocumentosEnvioType {
  idDocumento?: string
  idTipoDocumento: string
  nomeTipoDocumento?: string
  status?: string
  isDone?: boolean
}

export interface PropostaState {
  readonly dadosProposta: PropostaApi
  readonly dadosPropostaAntiga: PropostaApi
  readonly dadosPropostaError: boolean
  readonly loadingProposta: boolean
  readonly numeroProposta?: string | number

  readonly tipoDocumento: DocumentosEnvioType[] | undefined
  readonly idIteracao: string

  readonly loadingSalvarProposta: boolean
  readonly propostaEnviada: boolean
  readonly erroSalvarProposta: boolean

  readonly contato?: boolean
}

export interface PropostaApi {
  numeroParcelas: number
  valorParcela: string
  taxa: string
  cet: string
  percentualIOF: string
  valorIOF: string
  valorLiberado: string
  total: string
  primeiroDesconto: string
  ultimoDesconto: string
  taxaNominalContrato: string
  taxaNominalAnual: string
  jurosContratadosPercentual: string
  jurosContratados: string
  valorTotalDestinadoPagamentoSeguro: string
  percentualPropostaSeguroPrestamista: string
  tarifaCadastro: string
  taxaTarifaCadastro: string
  valorSolicitado: string
  valorSolicitadoPercentual: string
  valorOperacao: string
  valorDoMutuo: string
  atributosCetMensal: string
  atributosCetAnual: string
  dataNascimento: string
  nomeMae: string
  valorTotalASerPago: string
  quantidadeDeParcelas: number
  matricula: string
  tipoLiberacao: string
  jurosCapitalizados: boolean
  estipulante: string
  possuiSeguro: boolean
  dataEmissao: string
  enderecoResidencial: string
  cidadeResidencial: string
  estadoResidencial: string
  bairroResidencial: string
  numeroResidencial: string
  nomeCliente: string
  cpf: string
  nomeConjuge: string
  banco: string
  agencia: string
  conta: string
  nomePai: string
  cidadeNaturalidade: string
  estadoNaturalidade: string
  estadoCivil: string
  nacionalidade: string
  documentoIdentificacao: string
  taxaEfetivaMensal: string
  taxaEfetivaAnual: string
  orgao: string
  complementoResidencial: string
  cepResidencial: string
  cepResidencialComMascara: string
  dddCelular: string
  telefoneCelular: string
  codigoContratoOriginalPortabilidade: string
  bancoPortadoDescricao: string
  digitoContaCorrente: string
  profissao: string
  escolaridade: string
  contratosRefin: ContratosRefinState[]
  saldoDevedorTotalRefin: string
  email: string
  valorDaParcela: string
  convenio: string
  vencimentoPrimeiraParcela: string
  cnpjFinanceiraCredorPortabilidade: string
  prazoPortabilidade: string
  cnpjLojaMaster: string
  vlrTotalDevedor: string
  valorSaldoDevedorPortabilidade: string
}

export interface ContratosRefinState {
  numeroContratoRefin: string
  valorParcelaContratoRefin: string
  quantidadeParcelaContratoRefin: number
  numeroPropostaRefin: string
  saldoDevedorRefin: string
}

export interface DadosPropostaPayload {
  callback: () => void
}
export interface CallbackSalvarProposta {
  callback: () => void
}

export interface GetPropostasPayload {
  callback?: (data: PropostasResponse) => void
  errorCallback?: () => void
}

export interface PropostasResponse {
  errorCode?: string
  proposals: Array<{
    contract: string
    proposal: string
  }>
}
